module.exports = __webpack_public_path__ + "img/96c71af.jpg";